import React, { useCallback, useState, useEffect, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import Modal from "../../../../components/comm/Modal"
import AgreeConditionsBox from '../../../../components/box/AgreeConditionsBox';
import style from './MyHospitalConnection.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import URL, { DPAUTH_URL } from '../../../../constants/url';
import CircularProgress from '@mui/material/CircularProgress';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import noDataImg from '../../../../images/common/img_my_data_last_loading.svg';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import Skeleton from '@mui/material/Skeleton';

const MyHospitalConnection = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { hsptlCd = [], hsptlConntion = [] , hsptlNext = "" } = location.state || {};

    const [hsptlNotConnectedList, setHsptlNotConnectedList] = useState([]);
    const [selectedHospitals, setSelectedHospitals] = useState([]);
    const [isChecked, setIsChecked] = useState(false); // 체크박스 상태를 관리할 state
    const [isLoading, setIsLoading] = useState(false); // 상태 추가

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    useEffect(()=>{

        if(hsptlNext === "third"){
            setNext("third");
        }
        //console.log("========hsptlConntion : " , hsptlConntion)
        getClnicInfo();
    }, [])


    const getClnicInfo = useCallback(async () => {

        setIsLoading(true);

        const url = "/hsptl/retrieveHsptlNotConnectedInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                // 개발 <-> 운영 필터  .. start
                const noHsptlList = DPAUTH_URL.includes("dev") ? // 임시기간동안만이니 간단하게 구현..
                    mediInfo?.hsptlNotConnectedList
                    : mediInfo?.hsptlNotConnectedList?.filter(item => ["012","014","015","016"].includes(item.hsptlCd)); // 점진적 오픈시 [] 안에 코드 추가하고,
                // end.. 완전 오픈시에는 .. 필터 소스부 제거처리하고 .. setSelectedHospitals 에 mediInfo.hsptlNotConnectedList 넣도록하자!
                setHsptlNotConnectedList(noHsptlList);
                //console.log("hsptlNotConnectedList : ", mediInfo.hsptlNotConnectedList)

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            setIsLoading(false);
        });

    }, [navigate]);



    //bottom sheet
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(false);
    }, []);

    function onDismiss() {
        setOpen(false);
    }

    //모달창
    const [isOpen, setIsOpen] = useState(false);

    //선택완료 클릭시
    const [next, setNext] = useState("first");


    //로딩 모달
    const loadingModal = ()=> {
        setIsOpen(!isOpen);
    }

    //(임시) 모달창 클릭시 다음
    const loadingComplete = ()=> {
        setIsOpen(false);
        setNext("third");
    }

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked); // 체크박스의 현재 checked 상태를 state에 저장
    };

    //카카오 채널 이동
    const handleOnJoinMeeting = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <>
            <HeadSub title="병원 연결" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap'>


                        {/* 병원 선택 */}

                        {next === "first" ? (
                            <div className={style['content-box']}>


                                <div className='animation-2'>
                                    <div className={style['top-txt']}>
                                        <span> 연결 할 병원을 <b>모두</b> 선택해주세요 <br />
                                        단, 선택한 병원에 내 환자 정보가 존재하지 않을 경우 연결이 불가능합니다.</span>
                                    </div>

                                    <div className={style['select-list-box']}>
                                        <p>병원 선택</p>
                                        <ul>


                                            {isLoading ? (
                                                    Array.from({ length: 3 }).map((_, idx) => (
                                                        <li key={idx}>
                                                            <Skeleton variant="rectangular" width={'100%'} height={50} style={{borderRadius:'12px'}} />
                                                        </li>
                                                    ))
                                                ) : hsptlNotConnectedList?.length === 0 ? (
                                                    <li>
                                                        <div className={style['no-data-box']}>
                                                            <div className={style['img-box']}>
                                                            <object data={noDataImg} aria-hidden='true'></object>
                                                            </div>
                                                            <p>추가로 연결 가능한 병원이 없습니다.</p>
                                                        </div>
                                                    </li>
                                                ) : (

                                                    hsptlNotConnectedList?.map((item, index) => {

                                                    return (
                                                        <li key={index}>
                                                            <div className='chkbox-custom' data-chkbox='list-btn'>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`hospital_${item.hsptlCd}`}
                                                                    checked={selectedHospitals.some(h => h.hsptlCd === item.hsptlCd)}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked;
                                                                        setSelectedHospitals((prev) => {
                                                                        if (isChecked) {
                                                                            return [...prev, { hsptlCd: item.hsptlCd, hsptlNm: item.hsptlNm }];
                                                                        } else {
                                                                            return prev.filter(h => h.hsptlCd !== item.hsptlCd);
                                                                        }
                                                                        });
                                                                    }}
                                                                />
                                                                <label htmlFor={`hospital_${item.hsptlCd}`}>
                                                                    <span>{item.hsptlNm}</span>
                                                                </label>
                                                            </div>
                                                        </li>
                                                    )
                                                })

                                            )}
                                        </ul>
                                    </div>
                                </div>

                                <div className="bottom-fixed-box" data-border-line="top">
                                    <div className="inner-box">

                                        <div className='btn-layout' data-btn-num="2">
                                            <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={()=> navigate(-1)}>
                                                <span>취소</span>
                                            </button>
                                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=> {

                                                    if(selectedHospitals.length !== 0){
                                                        setNext("second")
                                                    }

                                                }}>
                                                <span>선택 완료</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ): null}




                        {/* 병원 선택 다음 */}
                        {next === "second" ? (

                            <div className={style['content-box']}>

                                <div className='animation-2'>

                                <div className={style['top-txt']}>
                                    <span> 병원 연결을 위해 아래 병원에서 <br />
                                    <b>{loginUser.usrNm}</b>님의 환자 정보를 조회합니다.</span>
                                </div>

                                <div className={style['select-list-box']}>
                                    <ul>
                                        {
                                            selectedHospitals.map((item, index)=>{
                                                return(
                                                    <li key={index}>
                                                        <div className='chkbox-custom' data-chkbox='list-btn'>
                                                            <input type="checkbox" id="hospital1" disabled/>
                                                            <label htmlFor="hospital1">
                                                                <span>{item.hsptlNm}</span>
                                                            </label>
                                                        </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>


                                </div>

                                <div className="bottom-fixed-box" data-height="auto">
                                    <div className="inner-box">

                                        <div className='btn-layout' data-btn-num="1" data-btn-direction="column" data-btn-position="left">

                                            {/**loadingModal*/}
                                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=>{
                                                //console.log("isChecked " , isChecked)

                                                    const hsptlCdArray = selectedHospitals.map(hospital => hospital.hsptlCd);
                                                    const hsptlNmArray = selectedHospitals.map(hospital => hospital.hsptlNm);

                                                    navigate(URL.MY_HOSPITAL_LINK, {
                                                        state: {
                                                            hsptlCd : hsptlCdArray,
                                                            hsptlNm : hsptlNmArray,
                                                        },
                                                    });

                                            }}>
                                                <span>다음</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        ): null}

                        {/* 병원 선택 결과 */}
                        {next === "third" ? (
                             <div className={style['content-box']}>

                                <div className='animation-2'>
                                    <div className={style['result-box']}>
                                        <div className={style['inner-box']}>
                                            <span className={style['success']}>연결 성공 <b>{hsptlConntion && Array.isArray(hsptlConntion) && hsptlConntion.length > 0 ? hsptlConntion.length : '0'}</b> </span>
                                            <span className={style['fail']}> 연결 실패 <b>{hsptlConntion && Array.isArray(hsptlConntion) && hsptlConntion.length > 0 ? hsptlCd.length - hsptlConntion.length : hsptlCd.length}</b> </span>
                                        </div>
                                    </div>

                                    <div className={style['result-list-box']}>
                                        <ul>
                                            {
                                                Array.isArray(hsptlConntion) && hsptlConntion.map((item, index) =>{
                                                    return (
                                                        <li key={index}>
                                                            <div className={style['top-box']}>
                                                                <p>{item.cnncHsptlNm} 병원</p>
                                                                <span className={style['status-s']}>연결 성공</span>
                                                            </div>
                                                            <span>내 환자 번호 {item.cnncPatntNo}</span>
                                                        </li>
                                                    )
                                                })
                                            }

                                            {
                                                hsptlNotConnectedList
                                                .filter(item => hsptlCd.some(item2 => item.hsptlCd === item2))
                                                .map((item, index) => {

                                                    const isConnected = Array.isArray(hsptlConntion) && hsptlConntion.some(conn => conn.cnncHsptlCd === item.hsptlCd);
                                                    const cnncPatntNo = Array.isArray(hsptlConntion) ? hsptlConntion.find(conn => conn.cnncHsptlCd === item.hsptlCd)?.cnncPatntNo : null;
                                                    return (
                                                        <li key={index}>
                                                            <div className={style['top-box']}>
                                                                <p>{item.hsptlNm} 병원</p>
                                                                {isConnected ? <span className={style['status-s']}>연결 성공</span> : <span className={style['status-f']}>연결 실패</span>}
                                                            </div>
                                                            {isConnected ? <span>내 환자 번호 {cnncPatntNo}</span> : ''}
                                                        </li>
                                                    )
                                                })
                                            }
                                            {/*
                                            <li>
                                                <div className={style['top-box'] }>
                                                    <p>%앞에서선택한 병원%</p>
                                                    <span className={style['status-s']}>연결 성공</span>
                                                </div>
                                                <span>내 환자 번호 %000000%</span>
                                            </li>
                                            <li>
                                                <div className={style['top-box'] }>
                                                    <p>%앞에서선택한 병원%</p>
                                                    <span className={style['status-f']}>연결 실패</span>
                                                </div>
                                                <span>내 환자 번호 %000000%</span>
                                            </li>
                                            */}
                                        </ul>
                                    </div>

                                    <div className={style['list-box']}>
                                        <ul>
                                            <li>
                                                <span>내 환자 정보가 존재하지 않는 병원은 연결할 수 없습니다.</span>
                                            </li>
                                            <li>
                                                <span>내 환자 정보가 존재하는 병원인데도 계속해서 연결 실패 시 케어플러스 고객센터로 문의해주세요.</span>
                                                {/* <ul>
                                                    <li>이메일 문의: service@careplus.com</li>
                                                    <li>전화 문의 : 00-0000-0000</li>
                                                </ul> */}
                                            </li>
                                        </ul>
                                    </div>

                                    <button className={style['notic-box']} onClick={()=> handleOnJoinMeeting('https://pf.kakao.com/_xlvxeHn/chat')}>
                                        <div className={style['icon-box']}>
                                            <div className={style['icon']}>
                                                <span className='blind'>카카오톡 채팅상담</span>
                                            </div>
                                        </div>
                                        <div className={style['notic-txt-box']}>
                                            <p className={style['top-p']}>
                                                <b>케어플러스</b>카카오채널 상담
                                            </p>
                                            <p className={style['bot-p']}>
                                                <span><b>평일</b> 09:00~17:00</span><i>/</i>
                                                <span><b>점심시간</b> 12:00~13:00</span>
                                            </p>
                                        </div>
                                    </button>



                                </div>

                                <div className="bottom-fixed-box" data-border-line="top">
                                    <div className="inner-box">

                                        <div className='btn-layout' data-btn-num="1">
                                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=>navigate(URL.MY_HOSPITAL_SETTING)}>
                                                <span>확인</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                         </div>

                        ): null }


                        <BottomSheet

                            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                            expandOnContentDrag={false} // 내용 드래그로 확장 방지

                            open={open}

                            onDismiss={onDismiss}
                            snapPoints={({ minHeight }) => minHeight}
                            blocking={true}
                            >
                            <AgreeConditionsBox onClose={onDismiss} title="개인정보 활용 동의">
                                <span>환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주려고, 동의하지 않으면 우리는 환자번호를 조회할수 없고 연동해줄수가 없단다환자번호 조회를하려면 이걸 동의해야 조회 해주</span>
                            </AgreeConditionsBox>
                        </BottomSheet>
                </div>
            </div>


            <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                <div className={'modal-box'} data-pad="normal" onClick={loadingComplete}>
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>환자 정보 조회중... </p>
                        </div>
                        <CircularProgress size="3.2rem" className='m-t-20'/>
                    </div>
                </div>
            </Modal>
        </>
    );
};


export default MyHospitalConnection;
